<script src="./index.js"></script>
<style src="./style.scss" lang="scss" scoped/>
<template>
  <div v-bind:class="{ 'input-field': true,  'error': true,}">
    <input type="radio" v-bind:id="id" v-bind:name="name" @change="handleInput" :checked="checked">
    <label>{{ label }}</label>
  </div>
</template>

